import React from "react";
import { connect } from "react-redux";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import ContentSettings from "../../components/ContentSettings/ContentSettings";
import BackgroundSettings from "../../components/BackgroundSettings/BackgroundSettings";
import TextSettings from "../../components/TextSettings/TextSettings";
import TitleSettings from "../../components/TitleSettings/TitleSettings";
import SubtitleSettings from "../../components/SubtitleSettings/SubtitleSettings";
import FooterSettings from "../../components/FooterSettings/FooterSettings";
import HeaderSettings from "../../components/HeaderSettings/HeaderSettings";
import ButtonSettings from "../../components/ButtonSettings/ButtonSettings";
import FieldSettings from "../../components/FieldSettings/FieldSettings";
import LinkSettings from "../../components/LinkSettings/LinkSettings";
import TableSettings from "../../components/TableSettings/TableSettings";
import LabelSettings from "../../components/LabelSettings/LabelSettings";
import "./TemplateSettings.css";
import MenuSettings from "../../components/MenuSettings/MenuSettings";
import ListExpansion from "../../../../../components/UI/ListExpansion/ListExpansion";
import ClientSettings from "../../components/InteractionSettings/ClientSettings/ClientSettings";
import ChartSettings from "../../components/ChartSettings/ChartSettings";
import ScrollbarSettings from "../../components/ScrollbarSettings/ScrollbarSettings";
import ConnectionSettings from "../../components/InteractionSettings/ConnectionSettings/ConnectionSettings";
import AgendaSettings from "../../components/InteractionSettings/AgendaSettings/AgendaSettings";
import ChatSettings from "../../components/InteractionSettings/ChatSettings/ChatSettings";

import ChatTwoToneIcon from '@material-ui/icons/ChatTwoTone';
import EventNoteTwoToneIcon from '@material-ui/icons/EventNoteTwoTone';
import PersonOutlineTwoToneIcon from '@material-ui/icons/PersonOutlineTwoTone';
import PollTwoToneIcon from '@material-ui/icons/PollTwoTone';
import EqualizerTwoToneIcon from '@material-ui/icons/EqualizerTwoTone';
import BorderTopTwoToneIcon from '@material-ui/icons/BorderTopTwoTone';
import BorderBottomTwoToneIcon from '@material-ui/icons/BorderBottomTwoTone';
import VerticalAlignBottomTwoToneIcon from '@material-ui/icons/VerticalAlignBottomTwoTone';
import TouchAppTwoToneIcon from '@material-ui/icons/TouchAppTwoTone';
import LinkTwoToneIcon from '@material-ui/icons/LinkTwoTone';
import SubjectTwoToneIcon from '@material-ui/icons/SubjectTwoTone';
import TitleTwoToneIcon from '@material-ui/icons/TitleTwoTone';
import SubtitlesTwoToneIcon from '@material-ui/icons/SubtitlesTwoTone';
import WrapTextTwoToneIcon from '@material-ui/icons/WrapTextTwoTone';
import BorderColorTwoToneIcon from '@material-ui/icons/BorderColorTwoTone';
import ImportContactsTwoToneIcon from '@material-ui/icons/ImportContactsTwoTone';
import MenuTwoToneIcon from '@material-ui/icons/MenuTwoTone';
import PanoramaTwoToneIcon from '@material-ui/icons/PanoramaTwoTone';
import StorefrontTwoToneIcon from '@material-ui/icons/StorefrontTwoTone';
import ExhibitorSettings from "../../components/InteractionSettings/ExhibitorSettings/ExhibitorSettings";
class TemplateLayout extends React.PureComponent {
  state = {
    backgroundAreaIsExpanded: false,
    titleAreaIsExpanded: false,
    textAreaIsExpanded: false,
    footerAreaIsExpanded: false,
    headerAreaIsExpanded: false,
    buttonAreaIsExpanded: false,
    linksAreaIsExpanded: false,
    backgroundColor: false,
    subtitleAreaIsExpanded: false,
    contentAreaIsExpanded: false,
    menuAreaIsExpanded: false,
    fieldAreaIsExpanded: false,
    tableAreaIsExpanded: false,
    image: false,
    template: null,
    dropdownOpen: false,
    lastCollapse: ""
  };
  handleChange = (color, e, path) => {
    const { dispatch } = this.props;
    const names = path.split(".");
    let value =
      [names[1]].toString() === "margin" ||
        [names[1]].toString() === "borderRadius"
        ? e.target.value + "px"
        : e.target.value;
    if (color) {
      value = color.hex;
    }
    if (e.target.value !== undefined && e.target.value.includes("http")) {
      value = `url(${e.target.value}) no-repeat fixed center`;
    }
    let templateCopy = {};
    if (names.length > 2) {
      templateCopy = {
        ...this.state.template,
        content: {
          ...this.state.template.content,
          [names[0]]: {
            ...this.state.template.content[names[0]],
            [names[1]]: {
              ...this.state.template.content[names[1]],
              [names[2]]: value
            }
          }
        }
      };
    } else {
      templateCopy = {
        ...this.state.template,
        content: {
          ...this.state.template.content,
          [names[0]]: {
            ...this.state.template.content[names[0]],
            [names[1]]: value
          }
        }
      };
    }
    dispatch(templateActions.update(templateCopy));
  };
  background = () => {
    this.setState({
      background: !this.state.backgroundColor,
      image: !this.state.image
    });
  };
  expandArea = area => {
    this.setState(
      {
        [area]: !this.state[area]
      },
      () => {
        if (this.state.lastCollapse !== area) {
          if (this.state.lastCollapse !== "") {
            this.setState({ [this.state.lastCollapse]: false }, () => {
              this.setState({ lastCollapse: area });
            });
          } else {
            this.setState({ lastCollapse: area });
          }
        }
      }
    );
  };
  render() {
/*     const { image, backgroundColor, template } = this.state; */
    return (
      <React.Fragment>
        <div>
          <ListExpansion
            footer={false}
            icon={<PanoramaTwoToneIcon />}

            description="Background"
          >
            <BackgroundSettings />
          </ListExpansion>
          <ListExpansion
            footer={false}
            icon={<BorderTopTwoToneIcon />}

            description="Header"
          >
            <HeaderSettings />
          </ListExpansion>
          <ListExpansion footer={false} icon={<MenuTwoToneIcon />}description="Menu">
            <MenuSettings />
          </ListExpansion>
          <ListExpansion
            footer={false}
            icon={<ImportContactsTwoToneIcon />}
            description="Content"
          >
            <ContentSettings />
          </ListExpansion>
          <ListExpansion
            footer={false}
            icon={<BorderBottomTwoToneIcon />}
            description="Footer"
          >
            <FooterSettings />
          </ListExpansion>
          <br /><br />

          <ListExpansion footer={false} icon={<TitleTwoToneIcon />}description="Title">
            <TitleSettings />
          </ListExpansion>
          <ListExpansion
            footer={false}
            icon="fa fa-square"
            icon={<SubtitlesTwoToneIcon />}
            description="Subtitle"
          >
            <SubtitleSettings />
          </ListExpansion>
          <ListExpansion
            footer={false}
            icon="fa fa-square"
            icon={<WrapTextTwoToneIcon />}
            description="InputLabel"
          >
            <LabelSettings />
          </ListExpansion>
          <ListExpansion
            footer={false}
            icon={<SubjectTwoToneIcon />}
            description="Paragraphs"
          >
            <TextSettings />
          </ListExpansion>
          <ListExpansion footer={false}             icon={<BorderColorTwoToneIcon />}description="Field">
            <FieldSettings />
          </ListExpansion>
          <br /><br />
          <ListExpansion
            footer={false}
            icon={<TouchAppTwoToneIcon />}
            description="Button"
          >
            <ButtonSettings />
          </ListExpansion>
          <ListExpansion footer={false}             icon={<LinkTwoToneIcon />}description="Links">
            <LinkSettings />
          </ListExpansion>
          <br /><br />
          <TableSettings />
          <ListExpansion
            footer={false}
            icon={<VerticalAlignBottomTwoToneIcon />}

            description="Scrollbar"
          >
            <ScrollbarSettings />
          </ListExpansion>
          <ListExpansion
            footer={false}
            icon={<EqualizerTwoToneIcon />}
            description="Chart"
          >
            <ChartSettings />
          </ListExpansion>
          <br /><br />
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    alert: state.alert,
    template: state.template
  };
}
export default connect(mapStateToProps)(TemplateLayout);
